import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import de from './translation/de.json';
import en from './translation/en.json';
import es from './translation/es.json';
import fr from './translation/fr.json';
import ja from './translation/ja.json';
import pl from './translation/pl.json';
import pt from './translation/pt.json';
import sv from './translation/sv.json';

export const defaultNS = 'translation';

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    defaultNS,
    debug: process.env.NODE_ENV === 'development',
    saveMissing: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      fr,
      de,
      en,
      es,
      ja,
      pl,
      pt,
      sv,
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: '__qc_i18nextLng',
      caches: ['localStorage'],
    },
  })
  .catch(() => {});

if (i18n.services.formatter) {
  i18n.services.formatter.add(
    'capitalize',
    (value = '') => `${value.substr(0, 1).toUpperCase()}${value.substr(1)}`,
  );
}

export default i18n;
